import DSCircularProgress from "../../system-design/DSCircularProgress";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";
import useCollectionsReviewedList from "../hooks/useCollectionsReviewedList";
import { DSBaseTable, DSTableCell } from "../../system-design/Table";
import { Column } from "../../system-design/Table/DSBaseTable/components/DSBaseTable";
import DSTextField from "../../system-design/DSTextField";
import CollectionsListAvatar from "./CollectionsListAvatar";
import CollectionReviewModal from "./CollectionReviewModal";
import {
  CollectionReviewStates,
  PopulatedDraftCollection,
} from "../../../api/collection";
import { useState } from "react";
import DSSwitch from "../../system-design/DSSwitch";

const CollectionsReview = () => {
  const [onlyPending, setOnlyPending] = useState(true);
  const {
    data: collections,
    fetchNextPage,
    isLoading,
    columns,
    handleSelectRow,
    handleTextSearch,
    handleCloseModal,
    isModalOpen,
    selectedCollection,
  } = useCollectionsReviewedList();

  const buildTableRows = (
    collection: PopulatedDraftCollection,
    columns: Column<PopulatedDraftCollection>[],
  ) => (
    <>
      {columns.map((col) => (
        <DSTableCell
          key={col.field as string}
          style={{
            width: col.size || `${100 / columns?.length}%`,
            whiteSpace: "nowrap",
          }}
        >
          {col.field === "coverUrl" ? (
            <DSBox>
              <CollectionsListAvatar collectionCover={collection.coverUrl} />
            </DSBox>
          ) : col.field === "reviewStatus" ? (
            collection.reviewStatus?.state || "N/A"
          ) : (
            String(collection[col.field])
          )}
        </DSTableCell>
      ))}
    </>
  );

  return (
    <>
      <DSBox mb={3} sx={{ marginRight: "20px" }}>
        <DSTypography variant="h6" mb={1}>
          Free Search
        </DSTypography>
        <DSTextField
          fullWidth
          variant="outlined"
          placeholder="Search Collections"
          onChange={(e) => {
            handleTextSearch(e.target.value);
          }}
        />
        <DSBox mt={1}>
          <DSSwitch
            title="Only Pending"
            checked={onlyPending}
            onChange={(e) => setOnlyPending(e.target.checked)}
          />
          <DSTypography variant="caption">
            Only show pending reviews
          </DSTypography>
        </DSBox>
      </DSBox>
      {collections && !isLoading ? (
        <>
          <DSBaseTable
            columns={columns}
            fetchMore={fetchNextPage}
            rowBuilder={buildTableRows}
            data={collections.filter((collection) =>
              onlyPending
                ? collection.reviewStatus?.state ===
                  CollectionReviewStates.Pending
                : true,
            )}
            onPressRow={(row) => handleSelectRow(row)}
          />
          {selectedCollection && (
            <CollectionReviewModal
              isModalOpen={isModalOpen}
              onClose={handleCloseModal}
              collection={selectedCollection}
            />
          )}
        </>
      ) : (
        !isLoading && (
          <DSTypography variant="body1" textAlign="center">
            <p>No Collections found in review</p>
          </DSTypography>
        )
      )}
      {isLoading && (
        <DSBox
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <DSCircularProgress />
        </DSBox>
      )}
    </>
  );
};

export default CollectionsReview;
